import React from 'react';
import './confirmation-message.scss';

const ConfirmationMessage = ({ message }) => {

  return (
    <div className="confirmation-message-container">
      {message}
    </div>
  );
};

export default ConfirmationMessage;
